import type { StackProps } from "@mui/material";
import { Stack } from "@mui/material";
import type { CrmField } from "./CrmFieldEdit";
import CrmFieldEdit from "./CrmFieldEdit";
import type { FieldMapping, MappingType } from "./fieldMappingsState";
import MappingObjectText from "./MappingObjectText";
import MappingTypeEdit from "./MappingTypeEdit";

interface Props {
  fieldMapping: FieldMapping;
  crmFields: CrmField[];
  hasError?: boolean;
  onChange: (fieldMapping: FieldMapping) => void;
  containerProps?: StackProps;
}

const CrmFieldMappingEdit = ({ fieldMapping, crmFields, hasError, onChange, containerProps = {} }: Props) => {
  const handleCrmFieldChange = (crmFieldId: string) =>
    onChange({
      entriliaFieldId: fieldMapping.entriliaFieldId,
      entriliaFieldName: fieldMapping.entriliaFieldName,
      crmFieldId,
      mappingType:
        crmFieldId === "" ? "None" : fieldMapping.mappingType === "None" ? "FromCrm" : fieldMapping.mappingType,
    });

  const handleMappingTypeChange = (mappingType: MappingType) =>
    onChange({
      entriliaFieldId: fieldMapping.entriliaFieldId,
      entriliaFieldName: fieldMapping.entriliaFieldName,
      crmFieldId: fieldMapping.crmFieldId,
      mappingType,
    });

  return (
    <Stack
      direction="row"
      spacing={1.5}
      {...containerProps}
      sx={[{ alignItems: "center" }, ...(Array.isArray(containerProps.sx) ? containerProps.sx : [containerProps.sx])]}
    >
      <MappingObjectText text={fieldMapping.entriliaFieldName} />
      <MappingTypeEdit mappingType={fieldMapping.mappingType} onChange={handleMappingTypeChange} />
      <CrmFieldEdit
        crmFieldId={fieldMapping.crmFieldId}
        options={crmFields}
        hasError={hasError}
        onChange={handleCrmFieldChange}
      />
    </Stack>
  );
};

export default CrmFieldMappingEdit;
